import React, { useState, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { pickBy } from 'lodash';
import { BlocksForm } from '@plone/volto/components';
import PropTypes from 'prop-types';

import DefaultEditBlockWrapper from '@plone/volto/components/manage/Blocks/Container/EditBlockWrapper';
import { v4 as uuid } from 'uuid';
import { blocksFormGenerator } from '@plone/volto/helpers';

import config from '@plone/volto/registry';

import './edit.less';
import './view.less';

const Edit = (props) => {
  const {
    block,
    data,
    direction = 'vertical',
    onChangeBlock,
    onChangeField,
    pathname,
    selected,
    navRoot,
  } = props;

  const intl = useIntl();
  const blockType = data['@type'];
  const metadata = props.metadata || props.properties;
  const isInitialized = data?.blocks && data?.blocks_layout;
  const defaultBlockType = config.settings.defaultBlockType;
  const properties = isInitialized
    ? data
    : blocksFormGenerator(1, defaultBlockType);
  const blockConfig = config.blocks.blocksConfig['gridBlock'];

  const blocksConfig = blockConfig.blocksConfig;
  const allowedBlocks = blockConfig.allowedBlocks.filter(
    (b) => b !== blockType, //to avoid inception :-D
  );

  // Custom components from config or default ones

  let [selectedBlock, setSelectedBlock] = useState(
    properties.blocks_layout.items[0],
  );
  if (props.setSelectedBlock) {
    ({ selectedBlock, setSelectedBlock } = props);
  }

  const blockState = {};

  const onAddNewBlock = () => {
    const newuuid = uuid();
    const type = allowedBlocks?.length === 1 ? allowedBlocks[0] : null;
    const blocks = data.blocks || properties.blocks;
    const blocks_layout = data.blocks_layout || properties.blocks_layout;
    const newFormData = {
      ...data,
      blocks: {
        ...blocks,
        [newuuid]: { '@type': type || defaultBlockType },
      },
      blocks_layout: {
        items: [...blocks_layout.items, newuuid],
      },
    };

    onChangeBlock(block, {
      ...newFormData,
    });
  };

  const allowedBlocksConfig = pickBy(blocksConfig, (value, key) =>
    allowedBlocks.includes(key),
  );

  return (
    <>
      <BlocksForm
        metadata={metadata}
        properties={properties}
        direction={direction}
        manage={false}
        selectedBlock={selected ? selectedBlock : null}
        blocksConfig={allowedBlocksConfig} //allowedBlocks
        title=""
        isContainer
        isMainForm={false}
        stopPropagation={selectedBlock}
        onSelectBlock={(id) => {
          setSelectedBlock(id);
        }}
        onChangeFormData={(newFormData) => {
          onChangeBlock(block, {
            ...data,
            ...newFormData,
          });
        }}
        onChangeField={(id, value) => {
          if (['blocks', 'blocks_layout'].includes(id)) {
            blockState[id] = value;
            onChangeBlock(block, {
              ...data,
              ...blockState,
            });
          } else {
            onChangeField(id, value);
          }
        }}
        pathname={pathname}
        editable={true}
      />
    </>
  );
};

export default React.memo(Edit);
